import React from 'react';
import { graphql, StaticQuery } from 'gatsby';

import Image from '@components/imgComp';

import * as styles from './styles.module.scss';

type Props = {
    uid: string;
    isAmp?: boolean;
};

const Banner: React.FunctionComponent<Props> = ({ uid, isAmp = false }) => (
    <StaticQuery
        query={graphql`
            query SideBannerQuery {
                allPrismicBanners {
                    edges {
                        node {
                            data {
                                image {
                                    url
                                    dimensions {
                                        width
                                        height
                                    }
                                    localFile {
                                        childImageSharp {
                                            gatsbyImageData(placeholder: BLURRED)
                                        }
                                    }
                                }
                                foot_note {
                                    raw
                                }
                                description {
                                    raw
                                }
                                link {
                                    raw
                                }
                                logo {
                                    url
                                    dimensions {
                                        width
                                        height
                                    }
                                    localFile {
                                        childImageSharp {
                                            gatsbyImageData(placeholder: BLURRED)
                                        }
                                    }
                                }
                                title {
                                    raw
                                }
                            }
                        }
                    }
                }
            }
        `}
        render={({ allPrismicBanners }) => {
            const { description, foot_note, image, link, logo, title } = allPrismicBanners?.edges[0].node.data;
            const linkUrl = link?.raw[0]?.spans[0]?.data?.url ?? 'https://start.leoandlea.com/v4';

            return (
                <div className={styles['side_banner']}>
                    {isAmp ? (
                        <amp-img
                            src={logo?.url}
                            alt={logo?.alt}
                            width={logo?.dimensions?.width}
                            height={logo?.dimensions?.height}
                        />
                    ) : (
                        <Image {...logo} />
                    )}
                    <p className={styles['title']}>
                        {title.raw.map(({ text, type }) => (
                            <span key={text} className={styles[type.includes('heading') ? 'header' : '']}>
                                {text}
                            </span>
                        ))}
                    </p>

                    <p className={styles['description']}>
                        {description.raw.map(({ text }: { text: string }) => (
                            <span key={text}>{text}</span>
                        ))}
                    </p>

                    {isAmp ? (
                        <amp-img
                            src={image?.url}
                            alt={image?.alt}
                            width={image?.dimensions?.width}
                            height={image?.dimensions?.height}
                        />
                    ) : (
                        <Image {...image} />
                    )}

                    <a href={`${linkUrl}?utm_source=wantimes&utm_medium=blog&utm_campaign=${uid}-sb`}>
                        {link?.raw[0]?.text}
                    </a>

                    <p className={styles['foot_note']}>
                        {foot_note.raw.map(({ text }: { text: string }) => (
                            <span key={text}>{text}</span>
                        ))}
                    </p>
                </div>
            );
        }}
    />
);

export default Banner;
